export default __webpack_public_path__ + "static/media/arrowBottom.c8b0e8fa.svg";